/* eslint-disable react/forbid-prop-types */
import PropTypes from 'prop-types';

import ControllersGroup from '../../../controllers/ControllersGroup';
import {
  InputLineController,
  ButtonLineController,
  SelectController,
  ChoiceBoxController,
  RangeController,
} from '../../../controllers/Base';

import fontOptions from '../../../utils/controllersUtils/options';

const defaultProps = {
  handle: () => {},
  config: undefined,
  extend: '',
  setExtend: () => {},
  isGlobalFontActive: false,
};

const AxisControllers = ({
  handle = defaultProps.handle,
  config = defaultProps.config,
  extend = defaultProps.extend,
  setExtend = defaultProps.setExtend,
  isGlobalFontActive = defaultProps.isGlobalFontActive,
}) => (
  <>
    <ControllersGroup title="Eixos" id="axis" extend={extend} setExtend={setExtend}>
      <ChoiceBoxController
        label="Posicionamento da escala"
        handle={handle}
        kWord="AxisPosition"
        options={config?.LayoutControl === 'vertical' ? [
          { value: 'before', label: 'Esquerda', id: 'before' },
          { value: 'after', label: 'Direita', id: 'after' },
        ] : [
          { value: 'before', label: 'Acima', id: 'before' },
          { value: 'after', label: 'Abaixo', id: 'after' },
        ]}
        configValue={config?.AxisPosition || 'after'}
        fullWidth
      />
      <SelectController
        label="Fonte"
        handle={handle}
        kWord="AxisGlobalFontFamily"
        options={fontOptions}
        text={config?.UseGlobalFont !== false && isGlobalFontActive ? 'Utilizando fonte global' : ''}
        configValue={config?.AxisGlobal?.fontFamily}
        disabled={(
          config?.UseGlobalFont !== false && isGlobalFontActive
        )}
        fullWidth
      />
      <InputLineController
        label="Tamanho"
        handle={handle}
        kWord="AxisGlobalFontSize"
        configValue={config?.AxisGlobal?.fontSize}
        min={1}
        max={30}
        step={1}
        precision={0}
        isNumber
      />
      <ButtonLineController
        handle={handle}
        fontColorVal={config?.AxisGlobal?.color || '#333333'}
        fontColorKWord="AxisGlobalFontColor"
      />
      <RangeController
        label="Rotação"
        handle={handle}
        kWord="AxisRotationControl"
        configValue={config?.AxisRotationControl}
        min={-180}
        max={180}
        fullWidth
      />
      <RangeController
        label="Posição horizontal"
        handle={handle}
        kWord="AxisTranslateX"
        configValue={config?.AxisTranslateX}
        min={-500}
        max={500}
        fullWidth
      />
      <RangeController
        label="Posição vertical"
        handle={handle}
        kWord="AxisTranslateY"
        configValue={config?.AxisTranslateY}
        min={-500}
        max={500}
        fullWidth
      />
    </ControllersGroup>
  </>
);

AxisControllers.propTypes = {
  config: PropTypes.objectOf(PropTypes.any),
  handle: PropTypes.func,
  extend: PropTypes.string,
  setExtend: PropTypes.func,
  isGlobalFontActive: PropTypes.bool,
};

export default AxisControllers;
